// QUÉ DICE CADA PASO DEL PRIMER ARRANQUE.
//
// =====================================================================
// EL TEXTO VIVE AQUÍ Y NO EN EL SERVIDOR, Y ES A PROPÓSITO
// =====================================================================
// El servidor contesta qué pasos hay y cuáles están hechos — eso es un
// hecho sobre la empresa—. Cómo se le explica a una persona qué es «dar
// de alta dónde guardas las cosas» es interfaz, y cambiarlo no puede
// exigir un despliegue del backend ni una migración.
//
// =====================================================================
// CADA PASO DICE TRES COSAS, Y LAS TRES HACEN FALTA
// =====================================================================
//   · QUÉ ES, en las palabras de quien trabaja en una bodega — nunca
//     «ubicación» a secas, que es palabra de programador.
//   · POR QUÉ AHORA, que es lo que hace que alguien lo haga en vez de
//     posponerlo. Sin esta línea el asistente es una lista de tareas.
//   · A DÓNDE SE VA, para que el paso se pueda hacer desde aquí. Un
//     asistente que dice qué falta y no lleva a hacerlo deja el trabajo
//     de buscar, que es la mitad del trabajo.
export const PASOS = {
  ubicaciones: {
    titulo: 'Dónde guardas las cosas',
    que: 'Un almacén, una bodega, un estante. Con uno basta para empezar; '
      + 'después puedes añadir pasillos y charolas.',
    porque: 'Hasta que exista un sitio, TEGO no puede apuntar dónde está '
      + 'nada — ni siquiera lo que ya tienes.',
    modulo: 'almacen',
    boton: 'Crear el primero',
  },
  personas: {
    titulo: 'Quién más va a entrar',
    que: 'Invita a quien trabaja contigo y dile qué puede hacer cada uno. '
      + 'Cada quien entra con su cuenta.',
    porque: 'Cuando cada persona entra con la suya, TEGO puede decir quién '
      + 'movió qué. Con una cuenta compartida, esa pregunta no tiene '
      + 'respuesta el día que hace falta.',
    modulo: 'usuarios',
    boton: 'Invitar a alguien',
  },
  // R-SD8/P6 (29 sep 2026): el atajo lleva a «Alta rápida» —nombre,
  // código, cuántos hay y dónde: el producto y su primera entrada de una
  // vez—, no al formulario completo de Productos. La lista de Excel se
  // sube desde Productos, y el texto lo dice.
  productos: {
    titulo: 'Qué manejas',
    que: 'Tu catálogo. Empieza con uno en «Alta rápida»: nombre, código, '
      + 'cuántos tienes y dónde están. Si ya tienes la lista en Excel, la '
      + 'subes después desde Productos.',
    porque: 'Es lo que llena el resto de TEGO: sin productos no hay '
      + 'existencias, ni etiquetas, ni conteos.',
    modulo: 'alta',
    boton: 'Dar de alta el primero',
  },
  calidad: {
    titulo: 'Si tus clientes te piden calidad',
    que: 'Enciende lo que te exijan: número de lote del proveedor al '
      + 'recibir, inspecciones, documentos controlados.',
    porque: 'Solo si te lo piden. Si no, déjalo apagado y sigue — TEGO '
      + 'funciona igual, y puedes encenderlo el día que llegue el primer '
      + 'auditor.',
    modulo: 'calidad-ajustes',
    boton: 'Decidir ahora',
  },
};

/** El texto de cabecera según cuánto falta. */
export function resumen(estado) {
  if (!estado) return null;
  if (estado.terminado) {
    return {
      titulo: 'Tu empresa ya está configurada',
      cuerpo: 'Los tres pasos básicos están hechos. Puedes seguir '
        + 'afinando cuando quieras.',
    };
  }
  const faltan = estado.faltan;
  return {
    titulo: faltan === estado.de
      ? 'Vamos a dejar TEGO listo para tu empresa'
      : `Te ${faltan === 1 ? 'falta 1 paso' : `faltan ${faltan} pasos`}`,
    cuerpo: faltan === estado.de
      ? 'Son tres cosas y se pueden hacer en cualquier momento. Puedes '
        + 'cerrar esto y volver luego: no se pierde nada.'
      : 'Puedes cerrar esto y volver luego: lo que ya hiciste se queda.',
  };
}
